<template>
  <div>
    <BaseTitle :title="$t('menu.assignment_grading')" :yearPeriode="titleData" />
    <v-card class="pa-8 mb-6">
      <v-row>
        <v-col cols="12" md="5" class="py-0">
          <h3 class="app-section-title mb-5">{{ $t('content.expected_point') }}</h3>
          <div>
            <form-group :name="$t('content.minimum_point')" :validator="$v.formPut.scoreMinimum">
              <template slot-scope="{ attrs }">
                <v-text-field
                  type="number"
                  v-bind="attrs"
                  v-number
                  v-model="formPut.scoreMinimum"
                  :min="0"
                  :max="formPut.scoreMaximum"
                  :label="$t('content.minimum_point')"
                  @input="maximum($event)"
                  @blur="$v.formPut.scoreMinimum.$touch()"
                />
              </template>
            </form-group>
          </div>
        </v-col>
        <v-col cols="12" md="5" class="py-0">
          <div class="mt-11">
            <form-group :name="$t('content.maximum_point')" :validator="$v.formPut.scoreMaximum">
              <template slot-scope="{ attrs }">
                <v-text-field
                  type="number"
                  v-number
                  v-bind="attrs"
                  :validator="$v.formPut.scoreMaximum"
                  v-model="formPut.scoreMaximum"
                  :min="0"
                  @keydown="nameKeydown($event)"
                  :disabled="typeId == 2"
                  :label="$t('content.maximum_point')"
                  @input="minimum($event)"
                  @blur="$v.formPut.scoreMaximum.$touch()"
                  @paste="onPaste"
                />
              </template>
            </form-group>
          </div>
        </v-col>
        <v-col cols="12" md="2" class="py-0">
          <div class="mt-11">
            <v-btn color="primary" class="btn-primary-custom mt-3" @click="convert">{{ $t('content.convert') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="mb-7">
      <v-card class="pa-8 mb-6">
        <div class="d-flex align-items-center justify-space-between">
          <h3 class="app-section-title mb-6">{{ $t('content.student_list') }}</h3>
          <div>
            <v-text-field v-model="search" :label="$t('search')">
              <template #prepend-inner>
                <svg-icon icon="ic-search" class="primary--text mr-3" />
              </template>
            </v-text-field>
          </div>
        </div>
        <v-data-table :headers="tableHeader" :items="form.students" :search="search" hide-default-footer class="table-custom">
          <template v-slot:item.fullName="{ item }">
            <span v-if="item.assignmentTypeId == 2 || item.assignmentTypeId == 1">{{ item.fullName }}</span>
            <span v-if="item.assignmentTypeId == 3 || item.assignmentTypeId == 4">{{ item.fullName }}</span>
            <span
              v-if="
                (item.newStudent === true && item.assignmentTypeId === 4) ||
                  (item.newStudent === true && item.assignmentTypeId === 2) ||
                  (item.newStudent === true && item.assignmentTypeId === 1)
              "
              class="text-caption green--text ml-2"
              style="font-size:5em;"
              >{{ $t('content.new_student') }}</span
            >
          </template>
          <template v-slot:item.submittedDate="{ item }">
            <b>
              <span v-if="item.late === true" class="red--text">{{ item.submittedDate }}</span>
              <span v-if="item.late === false" class="green--text">{{ item.submittedDate }}</span>
            </b>
          </template>

          <!-- <template #item.score="{ item }">
            <v-text-field v-if="item.newStudent === false" min="0" @keydown="nameKeydown($event)" v-model="item.score" type="number" />
            <span v-if="item.newStudent === true" class="green--text">{{ $t('content.attendance_new_student') }}</span>
          </template> -->

          <template #item.score="{ item }">
            <v-text-field
              v-if="item.excused === false"
              min="0"
              @keydown="nameKeydown($event)"
              @input="max({ $event, item, idx: form.students.indexOf(item) })"
              v-model="item.score"
              type="number"
            />
            <span v-if="item.excused === true">-</span>
          </template>
          <template #no-data>{{ $t('data_not_available') }}</template>
        </v-data-table>
      </v-card>
    </v-card>

    <div class="d-flex justify-end align-center">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
      <v-btn color="primary" :loading="loading" class="btn-primary-custom" @click="save">
        {{ $t('save') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'TeacherAssignmentCurveGrading',
  components: {
    BaseTitle
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    tableHeader() {
      return [
        { text: this.$t('table.name'), value: 'fullName', sortable: false },
        { text: this.$t('content.score'), value: 'score', sortable: false, width: 100 }
      ];
    },
    typeId() {
      return localStorage.getItem('assignmentTypeId');
    }
  },
  validations() {
    return {
      formPut: {
        scoreMinimum: { required },
        scoreMaximum: { required }
      }
    };
  },
  data: () => ({
    loading: false,
    dataClass: '',
    search: '',
    formPut: {
      scoreMinimum: '',
      scoreMaximum: ''
    },
    form: {
      students: []
    },
    titleData: ''
  }),
  methods: {
    onPaste(evt) {
      if (evt) {
        evt.preventDefault();
      }
    },
    max(e) {
      if (Number(e.$event) > Number(e.item.outOf)) {
        this.$nextTick(() => {
          this.form.students[e.idx].score = e.item.outOf;
        });
      }
    },
    maximum(e) {
      if (Number(e) > Number(this.formPut.scoreMaximum)) {
        this.$nextTick(() => {
          this.formPut.scoreMinimum = this.formPut.scoreMaximum;
        });
      }
      this.$v.formPut.scoreMinimum.$touch();
    },
    minimum(e) {
      if (Number(e) > Number(this.form.students[0].outOf)) {
        this.$nextTick(() => {
          this.formPut.scoreMaximum = this.form.students[0].outOf;
        });
      }
      this.$v.formPut.scoreMaximum.$touch();
    },
    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    getData() {
      this.$store
        .dispatch('Assignment/fetchDetail', this.$route.params.assignmentId)
        .then(res => {
          this.formPut.scoreMinimum = res.minimumPoint;
          this.formPut.scoreMaximum = res.totalPoint;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getStudent() {
      var data = localStorage.getItem('assignmentTypeId');
      // console.info(data);
      if (data == 2 || data == 1) {
        this.$store
          .dispatch('Assignment/fetchStudentQuizFile', this.$route.params.assignmentId)
          .then(res => {
            this.form.students = res;
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      } else {
        this.$store
          .dispatch('Assignment/fetchStudent', this.$route.params.assignmentId)
          .then(res => {
            this.form.students = res;
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      }
    },
    convert() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      // console.info(...this.formPut);
      var assignmentId = this.$route.params.assignmentId;
      this.loading = true;
      this.$store
        .dispatch('Assignment/convert', { ...this.formPut, assignmentId })
        .then(res => {
          if (res.data.data.canUpdate === true) {
            this.form.students = [];
            this.form.students = res.data.data.studentAssignments;
          } else {
            this.$store.dispatch('general/showErrorNotification', { message: 'Cannot Convert Grade' });
          }
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    back() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignmentDetail' });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSectionDetail' });
      }
    },
    save() {
      // this.form.students.forEach(data => {
      //   data.submittedDateInput = data.submittedDate;
      // });
      var assignmentId = this.$route.params.assignmentId;

      this.loading = true;
      this.$store
        .dispatch(`Assignment/updateStudent`, { ...this.form, assignmentId })
        .then(() =>
          this.$router.push({
            name: !this.$route.params.classSectionId ? 'TeacherGrupAssignmentSuccessGrading' : 'TeacherGrupAssignmentSectionSuccessGrading'
          })
        )
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    }
  },
  created() {
    this.getData();
    this.getDataClass();
    this.getStudent();
  }
};
</script>
